// @flow
import PasswordValidator from 'password-validator';
import {Map} from 'immutable';

const schema = new PasswordValidator();

schema
    .is().min(12)                                   // Minimum length 8
    .is().max(100)                                  // Maximum length 100
    .has().uppercase()                              // Must have uppercase letters
    .has().lowercase()                              // Must have lowercase letters
    .has().digits()                                 // Must have digits
    .has().symbols();                               // Must have special symbols

export const validatePassword = (password: string) => {
  let isValid = {
    all: true,
    min: true,
    max: true,
    uppercase: true,
    lowercase: true,
    digits: true,
    symbols: true
  };

  const ls = schema.validate(password, { list: true });

  if (ls.length === 0) {
    return isValid;
  }

  else {
    isValid.all = false;

    ls.forEach(d => {
      if (d === 'max') { isValid.max = false; }
      else if (d === 'min') { isValid.min = false; }
      else if (d === 'uppercase') { isValid.uppercase = false; }
      else if (d === 'lowercase') { isValid.lowercase = false; }
      else if (d === 'digits') { isValid.digits = false; }
      else if (d === 'symbols') { isValid.symbols = false; }
    });

    if(ls.length <= 1 && isValid.min && isValid.max) {
      isValid.all = true;
    }

    return isValid;
  }
};


// WEBPACK FOOTER //
// ./web_modules/trustar-2.0/util/validatePassword.js